export enum ContractTypesEnum {
  Individual = 'individual',
  LegalEntity = 'legal_entity',
  CivilLaw = 'civil_law',
  Entrepreneur = 'entrepreneur',
  Partnership = 'partnership',
}
